var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCodeAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.99303 4.80975C4.44123 2.24719 5.16533 0.965904 6.15898 0.636084C6.70558 0.454639 7.29442 0.454639 7.84102 0.636084C8.83467 0.965904 9.55875 2.24719 11.007 4.80975C12.4552 7.37229 13.1793 8.65359 12.9621 9.69759C12.8426 10.272 12.5481 10.7929 12.121 11.1858C11.3446 11.9 9.89643 11.9 7 11.9C4.10359 11.9 2.65538 11.9 1.87898 11.1858C1.45185 10.7929 1.15744 10.272 1.03793 9.69759C0.820716 8.65359 1.54482 7.37229 2.99303 4.80975Z",
    stroke: "#3C3E4C",
    strokeWidth: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99512 8.6001H7.00052",
    stroke: "#3C3E4C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 6.79992V4.3999",
    stroke: "#3C3E4C",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeAlert);
export default __webpack_public_path__ + "static/media/code_alert.acbc0c58d7d599e77721151f6e854fc2.svg";
export { ForwardRef as ReactComponent };